import { render, staticRenderFns } from "./ManualAdjustments.vue?vue&type=template&id=0180ef8c&scoped=true"
import script from "./ManualAdjustments.vue?vue&type=script&lang=js"
export * from "./ManualAdjustments.vue?vue&type=script&lang=js"
import style0 from "./ManualAdjustments.vue?vue&type=style&index=0&id=0180ef8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180ef8c",
  null
  
)

export default component.exports